export default __webpack_public_path__ + "d5947bc32d7548b79befbcb7b72ca6a1.svg";